import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import IconButton from '@/component/Button/IconButton';
import Translate from '@/component/Translate';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useTexts } from '@/feature/lang';
import { Icon } from '@/icon/Icon';
import { useRating } from './useRating';

const Container = styled('div', {
  name: 'Chatbot',
  slot: 'RatingContainer',
})(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  margin: theme.spacing(2),
  marginTop: 0,
  '&:last-child': {
    marginBottom: 0,
  },
}));

const SubContainer = styled('div', {
  name: 'Chatbot',
  slot: 'RatingSubContainer',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '&:not(:last-child)': {
    marginRight: theme.spacing(2),
  },
}));

const RatingTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
}));

export const RateLastResponse = () => {
  const texts = useTexts().component.chatbot;
  const { lastResponse, viewRating } = useRateLastResponse();
  const { castVote, options } = useRating(lastResponse);

  if (!viewRating) {
    return null;
  }

  return (
    <Container>
      <SubContainer>
        <RatingTypography>
          <Translate text={texts.rating.question} />
        </RatingTypography>
      </SubContainer>
      <SubContainer>
        <RatingTypography>
          {options.map((r, i) => (
            <IconButton key={i} onClick={() => castVote(r.rating)} size="small">
              <Icon name={r.icon} size="small" />
            </IconButton>
          ))}
        </RatingTypography>
      </SubContainer>
    </Container>
  );
};

export const useRateLastResponse = () => {
  const { messages } = useChatbot();
  const lastResponse = messages.findLast(
    (m) => m.sender === 'assistant' && !m.isReference
  );
  const { rating } = useRating(lastResponse);
  const viewRating = Boolean(
    lastResponse && !lastResponse.isStreaming && !rating
  );

  return { lastResponse, viewRating };
};
